import PropTypes from 'prop-types';
import useShow from '../../../../../hooks/shows/useShowFromURL';
import SlateInformation from '@/components/app/SlateInformation';
import { sliceGenres } from '@/helpers/common';
import useShowEdgePlayback from '@/hooks/audio/useShowEdgePlayback';
import pageKeys from '@/helpers/routing/constants';

const HeroShowContent = ({ includeMoreInfo }) => {
  const { show, isLoading } = useShow();

  const {
    title,
    id: showId,
    genres,
    description,
    slug,
    release_date
  } = show || {};

  const showHref = includeMoreInfo ? pageKeys.shows(slug) : undefined;

  const {
    paused,
    isLoading: playButtonIsLoading,
    handleClickPlay: onClickPlayFromHero,
    seasonNumberToPlay,
    episodeNumberToPlay,
    isCurrentlyPlayingShow
  } = useShowEdgePlayback({ showId });

  return (
    <SlateInformation
      description={ description }
      episodeNumber={ episodeNumberToPlay }
      genres={ sliceGenres({
        genres,
        limit: 2
      }) }
      hidePlayButton={ !playButtonIsLoading && !onClickPlayFromHero }
      hideShareButton
      isCurrentlyPlayingShow={ isCurrentlyPlayingShow }
      isPaused={ paused }
      isPlaying={ !paused }
      loading={ isLoading }
      loadingPlayButton={ playButtonIsLoading }
      onClickPlay={ onClickPlayFromHero }
      releaseDate={ release_date }
      seasonNumber={ seasonNumberToPlay }
      showHref={ showHref }
      title={ title }
    />
  );
};

HeroShowContent.propTypes = { includeMoreInfo: PropTypes.bool };

HeroShowContent.defaultProps = { includeMoreInfo: false };

export default HeroShowContent;